import { ResolveFn } from '@angular/router'
import { inject } from '@angular/core'
import { Store } from '@ngrx/store'
import { initializeStadiums } from '@features/stadiums/store/actions/stadiums.actions'

export const stadiumsResolver: ResolveFn<boolean> = () => {
  const store = inject(Store)

  store.dispatch(initializeStadiums())

  return true
}
